module.exports = __webpack_public_path__ + "static/Advantage02@3x.4ba81639.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage02@3x.png
// module id = 688
// module chunks = 216210090109534